// initial state
// shape: [{ id, quantity }]
const state = {}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getPriceBatchTable: ({commit, state}, params) => request.alert('getPriceBatchTable', params),
  createPriceBatch: ({commit, state}, params) => request.alert('createPriceBatch', params),
  searchPriceBatchItems: ({commit, state}, params) => request.alert('searchPriceBatchItems', params),
}

// mutations
const mutations = {}

export const priceBatchForm = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/price-batch/price-batch.store.js